import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ClaimsService } from '../services/claims.service';

@Injectable()
export class AdminGuard {

    constructor(
        private router: Router,
        private claimsService: ClaimsService
        ) { }

    canActivate() {

        const hasAnyClaims = this.claimsService.hasAnyClaims();

        if (!hasAnyClaims) {
            this.router.navigate(['/auth/login']);
        }

        const isAdminOrSuperAdmin = this.claimsService.isAdmin() || this.claimsService.isSuperUser();
        
        if (!isAdminOrSuperAdmin) {
            this.router.navigate(['/auth/logout']);
        }

        return isAdminOrSuperAdmin;
    }
}
